import axios from 'axios';

export const isUnsafeCampaignNameError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error) || error.response?.status !== 400) return false;

  const data = error.response.data;
  if (!data || typeof data !== 'object') return false;

  if (data.nameNotSafe || data.nameWrong) return true;

  return Array.isArray(data.errorCodes) && data.errorCodes.includes('UNSAFE_NAME');
};
